import { Inventory as PackageIcon } from '@mui/icons-material';
import React from 'react';

interface ListHeaderProps {
  totalItems: number;
}

const ListHeader: React.FC<ListHeaderProps> = ({ totalItems }) => {
  return (
    <div className='flex items-center justify-between mb-5 pb-4 border-b border-gray-100'>
      <div className='flex items-center gap-3'>
        <div className='p-2 rounded bg-[#ff750010] flex items-center justify-center'>
          <PackageIcon sx={{ fontSize: 20, color: '#ff7500' }} />
        </div>
        <div className='flex flex-col'>
          <h3 className='text-base font-semibold text-gray-700 leading-tight'>
            Pedidos Procesados ({totalItems})
          </h3>
          <span className='text-xs text-gray-400 leading-tight mt-0.5'>
            Últimos 10 pedidos procesados
          </span>
        </div>
      </div>
    </div>
  );
};

export default ListHeader;
